<template>
  <div id="app">
    <v-dialog/>
    <notifications group="message" position="top right" />
    <v-main-wrapper />
  </div>
</template>

<script>
import vMainWrapper from './components/v-main-wrapper.vue';

export default {
  name: 'app',
  components: {
    vMainWrapper,
  },
};
</script>
